export const LOCAL_STORAGE_KEYS = {
  USER_ID: 'userId',
  CUSTOMER_ID: 'customerId',
  USER: 'user',
  AUTHORIZATION_HEADER: 'X-Auth-Token',
  TC: 'tc',
  TC_TIME: 'tctime',
  COOKIE_AGREED: 'cookie-agreed',
  SHOW_SUMMER_GAME_NOTIFICATIONS : 'showSummerGameNotification'
};